import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Check for Google OAuth code in query params (self-hosted flow)
        const code = searchParams.get('code');
        
        if (code) {
          // Self-hosted Google OAuth callback
          console.log("Processing Google OAuth callback...");
          const response = await axios.post('/api/auth/google/callback', { code });
          
          navigate('/dashboard', { 
            state: { user: response.data },
            replace: true 
          });
          return;
        }
        
        // 18/09/2026 — ramo di login Emergent rimosso: si entra con Google.
        // No auth data found
        console.error("No auth data found in URL");
        navigate('/login');
        
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
